import React, { useState } from "react"
import { Offcanvas, CloseButton } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import TooltipX from 'react-bootstrap/Tooltip'
import { getFirestore, collection, getDocs } from 'firebase/firestore'
import { spinner } from "../utils/Helper"
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import PieMembers from "../utils/PieMembers"

export default function XReportz(props) {

    const [showCanvas, setShowCanvas] = useState(false);
    const handleCloseCanvas = () => setShowCanvas(false);
    const [pie, setPie] = useState(['']);
    const [data, setData] = useState(['']);

    const getMembers = () => {
        const db = getFirestore()
        const ref = collection(db, "profiles")
        const user = localStorage.getItem('isAnon')
        if (user == 'false') {
            //   setIsVisible(true)
        }
        spinner(true)
        getDocs(ref).then((snapshot) => {
            let rec = []
            snapshot.docs.forEach((doc) => {
                rec.push({ ...doc.data(), id: doc.id })
            })
            setData(rec)
            setPie(rec)
            spinner(false)
            setShowCanvas(true)
        }).catch(err => {
            spinner(false)
            toast.error(err.message)
        })
    }

    return (
        <>
            <OverlayTrigger overlay={<TooltipX >Reportz</TooltipX>}
            >
                <Button variant="primary" onClick={getMembers} className="hoverX ">
                   <span className="circle-btn centerCircle">🧩</span> Reportz
                </Button>
            </OverlayTrigger>
            <Offcanvas show={showCanvas} onHide={handleCloseCanvas} backdropClassName="adminBackdrop" className="bg-dark bordery" placement="end" >
                <Offcanvas.Header>
                     
                    <Offcanvas.Title>
                        <Offcanvas.Title>      <h3 className="xTitle modified animated rollIn ">
                            Reportz
                        </h3></Offcanvas.Title>
                    </Offcanvas.Title>
                     <CloseButton variant="white" onClick={handleCloseCanvas} />
                </Offcanvas.Header>
                <Offcanvas.Body  className="bg-dark bordery">

                    <PieMembers
                        data={pie}
                    ></PieMembers>

                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}